import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/i18n";

export const AnnouncementBar = () => {
  const { lang } = useLang();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((res) => setSettings(res.data)).catch(() => {});
  }, []);

  if (!settings || !settings.announcement_active) return null;
  const text = settings.announcement?.[lang] || settings.announcement?.en;
  if (!text) return null;

  return (
    <div data-testid="announcement-bar" className="bg-[#1A1F2C] text-white text-center text-xs tracking-luxe uppercase py-2.5 px-4">
      {text}
    </div>
  );
};
